import React, { useEffect, useRef, useState } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';

const ScrollingKatana = () => {
  const containerRef = useRef(null);
  const [isVisible, setIsVisible] = useState(true);
  const { scrollY } = useScroll();
  
  // Transform values based on scroll
  const heroHeight = typeof window !== 'undefined' ? window.innerHeight : 800;
  
  // Katana moves down and rotates as user scrolls
  const y = useTransform(scrollY, [0, heroHeight], [0, heroHeight * 0.8]);
  const rotate = useTransform(scrollY, [0, heroHeight * 0.5, heroHeight], [0, 45, 90]);
  const scale = useTransform(scrollY, [0, heroHeight], [1, 0.6]);
  const opacity = useTransform(scrollY, [heroHeight * 0.8, heroHeight * 1.2], [1, 0]);

  useEffect(() => {
    import('@google/model-viewer').catch(console.error);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPos = window.scrollY;
      // Hide katana after about section, show again at experience timeline
      const aboutSection = document.querySelector('#about');
      const experienceSection = document.querySelector('#experience');
      
      if (aboutSection && experienceSection) {
        const aboutBottom = aboutSection.offsetTop + aboutSection.offsetHeight;
        const expTop = experienceSection.offsetTop;
        
        if (scrollPos > aboutBottom && scrollPos < expTop - 200) {
          setIsVisible(false);
        } else {
          setIsVisible(true);
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <motion.div
      ref={containerRef}
      className="fixed z-30 pointer-events-none"
      style={{ 
        y,
        rotate,
        scale,
        opacity: isVisible ? opacity : 0,
        width: '100vw',
        height: '400px',
        top: '50%',
        left: '0%',
        transform: 'translate(-50%, -50%)',
      }}
    >
      <div className="relative w-full h-full">
        {/* 3D Katana Model */}
        <model-viewer
          src="/models/katana.glb"
          alt="Katana"
          camera-controls={false}
          disable-zoom
          disable-pan
          disable-tap
          interaction-prompt="none"
          shadow-intensity="0"
          exposure="1.5"
          style={{
            width: '100%',
            height: '100%',
            background: 'transparent',
          }}
          camera-orbit="0deg 90deg 1.8m"
          field-of-view="20deg"
        />
        
        {/* Horizontal shine pulse animation */}
        <motion.div
          className="absolute top-1/2 -translate-y-1/2 left-0 right-0 h-[2px] pointer-events-none"
          style={{
            background: 'linear-gradient(90deg, transparent 0%, transparent 40%, rgba(255,255,255,0.9) 50%, transparent 60%, transparent 100%)',
          }}
          animate={{ x: ['-100%', '100%'] }}
          transition={{
            duration: 2,
            repeat: Infinity,
            repeatDelay: 2,
            ease: 'easeInOut',
          }}
        />
        
        {/* Glow effect */}
        <motion.div
          className="absolute inset-0 pointer-events-none"
          animate={{ opacity: [0, 0.2, 0] }}
          transition={{ duration: 2, repeat: Infinity, repeatDelay: 2 }}
        >
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-8 bg-white/10 blur-xl" />
        </motion.div>
      </div>
    </motion.div>
  );
};

export default ScrollingKatana;
